import { ObjectSchema, array, object, string } from 'yup';
import { useMemo } from 'react';
import { SetupProviderFormState } from '@Forms/providers/SetupProviderFormContext';

export const useSetupProviderUseCaseSchema = (): ObjectSchema<Partial<SetupProviderFormState>> => {
  return useMemo(
    () =>
      object<SetupProviderFormState>().shape({
        name: string().required('name is required'),
        apiUrl: string().required('api url is required'),
        syncRoundEnd: string().required('sync round end url is required'),
        status: string().required('status is required'),
        retryScheduledSendCredit: string().required('retry scheduled send credit url is required'),
        retryConfigId: string().optional(),
        refundOnCreditFail: string().required('refund on credit fail is required'),
        filterExternalProviderBets: string().required(
          'filter external provider bets is required field'
        ),
        isInternal: string().required('is internal is required field'),
        configId: string().optional(),
        creditOnDisconnect: string().required('credit on disconnect is required'),
        games: array()
          .min(1, 'games array must have at least one game')
          .required('games is required field'),
        integrationType: string().required('integration type is required'),
      }),
    []
  );
};
